import React from "react";

const ErrorText = ({ errorText }) => {
  return (
    <div className="">
      <p className="secondpage-error-text">{errorText}</p>
    </div>
  );
};

export default ErrorText;
